import { SYSTEM_COLORS } from 'constants/colors';

export const PresenceUserStatus = {
  ACTIVE: 'Active',
  IDLE: 'Idle',
};

// Must match the server's PresenceEntityType member names — they are interpolated into Redis
// keys and SignalR group names, so a value here that differs from the enum silently splits the
// group and nobody sees anybody.
export const PresenceEntityType = {
  LOAN: 'Loan',
  TPO_SIGNUP_CONFIGURATION: 'TpoSignupConfiguration',
};

export const PRESENCE_ACTION_NAME_PREFIX = 'presence*';

export const PresenceSignalREventType = {
  USER_JOINED_LOAN: 'UserJoinedLoan',
  USER_LEFT_LOAN: 'UserLeftLoan',
  USER_LOCATION_CHANGED: 'UserLocationChanged',
  USER_STATUS_CHANGED: 'UserStatusChanged',
  FIELD_LOCK_ACQUIRED: 'FieldLockAcquired',
  FIELD_LOCK_RELEASED: 'FieldLockReleased',
  FIELD_LOCK_DENIED: 'FieldLockDenied',
  PRESENCE_SNAPSHOT: 'PresenceSnapshot',
  FIELD_VALUE_CHANGING: 'FieldValueChanging',
  FIELD_VALUE_COMMITTED: 'FieldValueCommitted',
  FIELD_VALUES_REVERTED: 'FieldValuesReverted',
  PENDING_FIELD_VALUES: 'PendingFieldValues',
};

export const PresenceSignalRMessageType = {
  JOIN_LOAN_PRESENCE: 'joinLoanPresence',
  LEAVE_LOAN_PRESENCE: 'leaveLoanPresence',
  HEARTBEAT: 'heartbeat',
  UPDATE_LOCATION: 'updateLocation',
  ACQUIRE_FIELD_LOCK: 'acquireFieldLock',
  RELEASE_FIELD_LOCK: 'releaseFieldLock',
  RELEASE_FIELD_LOCKS: 'releaseFieldLocks',
  UPDATE_FIELD_VALUE: 'updateFieldValue',
  COMMIT_FIELD_VALUE: 'commitFieldValue',
  REVERT_FIELD_VALUES: 'revertFieldValues',
};

export const HEARTBEAT_INTERVAL_MS = 5000;

export const IDLE_TIMEOUT_MS = 120000;

export const ACTIVITY_THROTTLE_MS = 5000;

export const FIELD_VALUE_BROADCAST_THROTTLE_MS = 500;

export const PRESENCE_REJOIN_GRACE_MS = 10000;

export const ACTIVITY_EVENTS = ['mousemove', 'keydown', 'click', 'scroll'];

export const PRESENCE_NOTIFICATION_TYPE = {
  JOINED: 'joined',
  LEFT: 'left',
};

const PRESENCE_COLOR_COUNT = 20;

/**
 * First 20 colors from the unified SYSTEM_COLORS palette.
 * Re-exported here to keep presence imports unchanged.
 */
export const PRESENCE_USER_COLORS = SYSTEM_COLORS.slice(0, PRESENCE_COLOR_COUNT);

export const getColorByIndex = index => {
  const safeIndex = Math.abs(index) % PRESENCE_USER_COLORS.length;

  return PRESENCE_USER_COLORS[safeIndex];
};

const HASH_MULTIPLIER = 31;

const hashIdentity = identity => {
  const normalized = identity == null ? '' : String(identity);
  const chars = Array.from(normalized);

  return chars.reduce((acc, char) => (acc * HASH_MULTIPLIER + char.charCodeAt(0)) | 0, 0);
};

export const getColorByUserId = userId => getColorByIndex(hashIdentity(userId));
